/**
 * Official UTMify tracking scripts.
 *
 * 1. UTM tracker (utms/latest.js) — always loaded, no account id required.
 * 2. UTMify Pixel (pixel/pixel.js) — only loaded when a REAL pixel id is set below.
 *    Paste your own id from the UTMify dashboard (Pixel > Configuração).
 *    Leaving it empty is safe: the pixel script crashes ("wt.lead._id") if the id
 *    does not belong to an existing UTMify account.
 */

export const UTMIFY_PIXEL_ID = ''

let loaded = false

export function loadUtmify(pixelId: string = UTMIFY_PIXEL_ID): void {
  if (loaded || typeof document === 'undefined') return
  loaded = true

  // UTMify — UTM parameters tracker
  const utmScript = document.createElement('script')
  utmScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js'
  utmScript.async = true
  utmScript.defer = true
  utmScript.setAttribute('data-utmify-prevent-xcod-sck', '')
  utmScript.setAttribute('data-utmify-prevent-subid', '')
  document.head.appendChild(utmScript)

  // UTMify — Pixel (requires a valid account pixel id)
  if (!pixelId) return

  const win = window as unknown as Record<string, unknown>
  win.pixelId = pixelId
  const pixelScript = document.createElement('script')
  pixelScript.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js'
  pixelScript.async = true
  pixelScript.defer = true
  document.head.appendChild(pixelScript)
}
